/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { getColor } from '@airasia-phoenix/react-native/utils/utils';
import { StyleSheet } from 'react-native-unistyles';
import { responsiveTextStyle } from '../../utils/responsiveTextStyle';

const styles = StyleSheet.create((pd) => ({
  mainContainer: {
    paddingTop: pd.ref.space.spacing20.px,
    gap: pd.ref.space.spacing40.px,
  },
  pinContainer: {
    width: '100%',
    marginTop: pd.ref.space.spacing70.px,
    marginBottom: pd.ref.space.spacing40.px,
    gap: pd.ref.space.spacing20.px,
  },
  pinField: {
    marginLeft: 0,
  },
  pinFieldError: {
    marginLeft: 0,
    borderColor: getColor(pd.sys.colour.sentiment_high),
  },
  pinTextError: {
    color: getColor(pd.sys.colour.sentiment_high),
  },
  title: responsiveTextStyle(
    pd.sys.typescale.heading_3,
    pd.sys.typescale.heading_2,
    pd.sys.colour.content_primary,
  ),
  subtitle: responsiveTextStyle(
    pd.sys.typescale.body_text,
    pd.sys.typescale.heading_4,
    pd.sys.colour.content_primary,
  ),
  inlineError: responsiveTextStyle(
    pd.sys.typescale.body_text,
    pd.sys.typescale.heading_4,
    pd.sys.colour.sentiment_high,
  ),
  timerText: responsiveTextStyle(
    pd.sys.typescale.sub_body_text,
    pd.sys.typescale.body_text,
    pd.sys.colour.content_secondary,
  ),
}));

export default styles;
